<template>
  <div id="operate">
    <div class="trader-ban">
      <img v-if="pzPath === 'Operateday'" :src="operatedayBg">
      <img v-else-if="pzPath === 'Operateweek'" :src="operateweekBg">
      <img v-else-if="pzPath === 'Operatemonth'" :src="operatemonthBg">
      <img v-else-if="pzPath === 'Operatehuhui'" :src="operatehuhuiBg">
      <img v-else-if="pzPath === 'Operatevip'" :src="operatevipBg"> 
    </div>
    <div class="trader-toggle">
      <div class="trader-toggle-cen">
        <el-row :gutter="100">
          <el-col :span="2">
            <router-link to="/operate/operateday" class="assist" >
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/operate/operateday" class="assist" style="background: linear-gradient(to bottom, #FF646E, #FF121D);">
<!--              <img src="../assets/img/atpz.png">-->
              <span>{{$t('pc.home.day_capital')}}</span>
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/operate/operateweek" class="assist" style="background: linear-gradient(to bottom, #fbb65d, #c67b18);">
              {{$t('pc.home.week_capital')}}
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/operate/operatemonth" class="assist" style="background: linear-gradient(to bottom, #D1B08A, #9B6E44);">
              {{$t('pc.home.month_capital')}}
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/operate/operatehuhui" class="assist" style="background: linear-gradient(to bottom, #5285AF, #165085);">
              {{$t('pc.home.interest_free_capital')}}
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/operate/operatevip" class="assist" style="background: linear-gradient(to bottom, #478563, #168548);">
              {{$t('pc.home.vip_capital')}}
            </router-link>
          </el-col>
          <el-col :span="2">
            <router-link to="/operate/operateday" class="assist">
            </router-link>
          </el-col>
        </el-row>

      </div>

      <!--<div class="trader-toggle-cen">
        <router-link to="/operate/operateday" active-class="Active">
          <i class="iconfont icon-tian"></i>按天配资
        </router-link>
        <router-link to="/operate/operateweek" active-class="Active">
          <i class="iconfont icon-week"></i>按周配资
        </router-link>
        <router-link to="/operate/operatemonth" active-class="Active">
          <i class="iconfont icon-yue"></i>按月配资
        </router-link>
        <router-link to="/operate/operatehuhui" active-class="Active">
          <i class="iconfont icon-hui"></i>免息配资
        </router-link>
      </div>-->
    </div>
    <!-- <keep-alive> -->
      <router-view name="child"></router-view>
    <!-- </keep-alive> -->
  </div>
</template>
<script>
import $ from "jquery";

export default {
  name: "operate",
  components: {
  },
  data() {
    return {
      pzPicture:{
        'Operateday': require('../assets/img/operateDay.png'),
        'Operateweek': require('../assets/img/operateWeek.jpg'),
        'Operatemonth' : require('../assets/img/operateMonth.png'),
        'Operatehuhui' : require('../assets/img/operateHuhui.png'),
        'Operatevip' : require('../assets/img/operateVip.png') //add by kasun, added image url for operate vip
      },
      pzPath:'Operateday',
      operatedayBg :"",
      operateweekBg :"",
      operatemonthBg :"",
      operatehuhuiBg :"",
      operatevipBg :"",
    };
  },
  mounted() {
    // $("#wrapper").css("background", "#737373");
    $("body,html").css({ overflow: "inherit", height: "100%" });
    this.pzPath = this.$route.name;
    this.get_bg_imgs();
  },
  methods: {
    get_bg_imgs(){
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "create_capital_bg",
          }
        })
        .then(function(res) {
          console.log(res)
          if (res.data.code == 1) {
            that.operatedayBg = res.data.data.day_capital_bg_pc|| require("@/assets/img/operateDay.png");
            that.operateweekBg = res.data.data.week_capital_bg_pc|| require("@/assets/img/operateWeek.jpg");
            that.operatemonthBg = res.data.data.month_capital_bg_pc|| require("@/assets/img/operateMonth.png");
            that.operatehuhuiBg = res.data.data.int_free_capital_bg_pc|| require("@/assets/img/operateHuhui.png");
            that.operatevipBg = res.data.data.vip_capital_bg_pc|| require("@/assets/img/operateVip.png");
          } else {
          }
        });
    },

  },
  watch:{
    $route(to,from){
      this.pzPath = this.$route.name;
    }
  },
};
</script>
<style scoped>
#operate{
  min-width: 1000px;
}
.trader-ban {
  /*height: 500px;*/
  overflow: hidden;
}
.trader-ban img {
  width: 100%;
}
.trader-ban img {
  width: 100%;
}
.trader-toggle {
  width: 100%;
  /*line-height: 50px;*/
  background-color: #f3f3f3;
  border-top: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
  margin: 0 0 20px;
}
.trader-toggle-cen {
  width: 1400px;
  margin: 0 auto;
  justify-content: space-between;
}
.trader-toggle-cen a {
  margin: 10px 0;
  text-align: center;
  color: #fff;
  font-size: 18px;
  line-height: 50px;
  display: block;
  border-radius: 4px;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
/*.trader-toggle-cen a > i {
  display: inline-block;
  font-size: 35px;
  line-height: 50px;
  vertical-align: top;
}*/
.trader-toggle-cen img {
  width: 15%;
}
  .assist{

  }
</style>





// WEBPACK FOOTER //
// src/components/operate.vue